/**
 * Created by 丸子 on 2018/7/23 0023.
 */
import Vue from 'vue'
import {formatDate} from '../util'

Vue.filter('formatDate', formatDate)
Vue.filter('log', console.log)
